module.exports = __webpack_public_path__ + "static/media/GmarketSansMedium.dcdb13e4.otf";